<template>
  <div class="pb-3">
    <va-card :title="$t(`sendNotification.title`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(send)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="required" name="Titulo da Mensagem" v-slot="{ errors }">
                <va-input
                  v-model="notificacao.title"
                  :label="$t('sendNotification.forms.titleLabel')"
                  :placeholder="$t('sendNotification.forms.titlePlaceholder')"
                  :success="errors.length == 0 && notificacao.title.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="Corpo da Mensagem" v-slot="{ errors }">
                <va-input
                  v-model="notificacao.subtitle"
                  :label="$t('sendNotification.forms.bodyLabel')"
                  :placeholder="$t('sendNotification.forms.bodyPlaceholder')"
                  :success="errors.length == 0 && notificacao.subtitle.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <div class="form-group mb-3">
                <va-select
                  :label="$t('weeks.forms.notifyLabel')"
                  v-model="notify"
                  textBy="name"
                  keyBy='id'
                  no-clear
                  :placeholder="$t('weeks.forms.notifyPlaceholder')"
                  :noOptionsText="$t('weeks.forms.notifyNoOption')"
                  maxHeight='200px'
                  :options="optionsNotify"
                />
              </div>
            </div>
            <div class="d-flex mt-1">
              <va-button
                type="submit"
                :disabled="buttonSubmitDisabled"
                color="success"
                class="my-0">
                {{ textSubmit }}
              </va-button>
              <va-button
                type="button"
                class="my-0"
                color="danger"
                @click="cancel">
                {{ $t("forms.cancel") }}
              </va-button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
export default {
  name: 'sendNotification',
  data () {
    return {
      notificacao: {
        title: '',
        subtitle: '',
      },
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.send'),
      optionsNotify: [
        {
          id: 'bolao', name: 'Bolão',
        },
        {
          id: 'ranking', name: 'Ranking',
        },
      ],
      notify: {
        id: 'bolao', name: 'Bolão',
      },
    }
  },
  methods: {
    cancel () {
      this.$emit('close', false)
    },
    send () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.sending')
      const self = this
      this.$axios.post(
        `/api/messaging/${this.notify.id}`,
        {
          title: this.notificacao.title,
          body: this.notificacao.subtitle,
        },
      ).then(response => {
        self.buttonSubmitDisabled = false
        self.textSubmit = self.$t('forms.send')
        self.$emit('close', false)
        self.showToast(
          self.$t('toasts.successSend'),
          {
            icon: 'fa-check',
            position: 'top-right',
            duration: 1000,
            fullWidth: false,
          },
        )
      })
        .catch(e => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.send')
          self.showToast(
            self.$t('toasts.errorSend'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>
